import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import SEOProvider from './providers/SEOProvider';
import Layout from './components/Layout/Layout';
import { useOfflineEventSync } from './hooks/useAnalytics';

// Lazy load pages for better performance
const HomePage = lazy(() => import('./pages/HomePage'));
const CarListingPage = lazy(() => import('./pages/CarListingPage'));
const CarDetailPage = lazy(() => import('./pages/CarDetailPage'));
const LoanCalculatorPage = lazy(() => import('./pages/LoanCalculatorPage'));
const FAQPage = lazy(() => import('./pages/FAQPage'));
const TermsPage = lazy(() => import('./pages/TermsPage'));
const PrivacyPage = lazy(() => import('./pages/PrivacyPage'));
const CookiePage = lazy(() => import('./pages/CookiePage'));
const BlogList = lazy(() => import('./pages/BlogList'));
const BlogDetail = lazy(() => import('./pages/BlogDetail'));

// Loading component
const PageLoader = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-red-600"></div>
  </div>
);

// Yeni sayfalar eklendikçe burada import edilecek
// import LoginPage from './pages/LoginPage';
// import RegisterPage from './pages/RegisterPage';
// import ProfilePage from './pages/ProfilePage';

const App: React.FC = () => {
  // Initialize offline event syncing
  useOfflineEventSync();

  return (
    <SEOProvider>
      <Router>
        <Suspense fallback={<PageLoader />}>
          <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/cars" element={<CarListingPage />} />
          <Route path="/car/:id" element={<Layout><CarDetailPage /></Layout>} />
          <Route path="/loan-calculator" element={<LoanCalculatorPage />} />
          <Route path="/blog" element={<Layout><BlogList /></Layout>} />
          <Route path="/blog/:id" element={<Layout><BlogDetail /></Layout>} />
          <Route path="/faq" element={<Layout><FAQPage /></Layout>} />
          <Route path="/terms" element={<Layout><TermsPage /></Layout>} />
          <Route path="/privacy" element={<Layout><PrivacyPage /></Layout>} />
          <Route path="/cookies" element={<Layout><CookiePage /></Layout>} />
          {/* Diğer sayfalar hazır olduğunda bu Route'lar aktif edilecek */}
          {/*
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          */}
          <Route path="*" element={
            <div className="flex items-center justify-center min-h-screen bg-gray-100">
              <div className="text-center">
                <h1 className="text-6xl font-bold text-gray-800 mb-4">404</h1>
                <p className="text-2xl text-gray-600 mb-8">Page Not Found</p>
                <Link to="/" className="px-6 py-3 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 transition duration-300">
                  Go Back Home
                </Link>
              </div>
            </div>
          } />
          </Routes>
        </Suspense>
      </Router>
    </SEOProvider>
  );
};

export default App;
